import { path as messagesPath } from "../messages/path";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const createMessageRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.createMessage.route,
      lazy: () => import("@pages/panelPages/newMessage/newMessage"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.newMessage",
          [
            {
              title: "pageTitle.messages",
              url: messagesPath.messages.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: [
      "admin",
      "super-admin",
      "local-admin",
      "staff",
      "doctor",
      "patient",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
